import { Msg } from 'nats.ws';
import { Event } from '../Event';
import StClient from '../StClient';

export class NatsObject<T> {
	client: StClient;
	subject: string;

	constructor(client: StClient, subject: string) {
		this.client = client;
		this.subject = subject;
	}

	subscribe<T> (type: string, listenFn: (event: Event<T>, message: Msg) => void) {
		const sub = this.client.subscribe(`${this.subject}.${type}`);

		(async () => {
			for await (const message of sub) {
				listenFn(message.json(), message);
			}
		})();

		return sub;
	}
}

export { NatsObject as default };
